// Japanese translations
const ja = {
  // Placeholder structure to prevent errors
  navigation: {
    tracking: "追跡",
    search: "検索",
    login: "マイアカウント",
    language: "言語"
  },
  
  menu: {
    solutions: "ソリューション",
    industries: "産業",
    ebusiness: "eビジネス",
    sustainability: "持続可能性",
    aboutUs: "会社概要",
    schedules: "スケジュール"
  },
  
  hero: {
    leaderIn: "リーダー",
    shippingLogistics: "海運と物流",
    trackingTab: "追跡",
    schedulesTab: "スケジュール",
    contactsTab: "お問い合わせ",
    containerBol: "コンテナ/船荷証券番号",
    bookingNumber: "予約番号",
    searchPlaceholder: "サービスとソリューションを検索...",
    searchButton: "検索"
  },
  
  // Default fallback for other sections
  example: {},
  services: {},
  stats: {
    title: "グローバルリーチ、ローカル専門知識",
    description: "堅牢なグローバルネットワークと深いローカルナレッジにより、大陸間のビジネスをつなぎます。",
    years: "年の経験",
    countries: "サービス提供国",
    clients: "アクティブな顧客",
    shipments: "年間出荷量"
  },
  industries: {},
  footer: {}
};

export default ja; 